<template>
  <keep-alive>
    <div class="uni-header">
      <div class="container">
        <div class="shool-box">
          <!-- <img
            v-if="background"
            class="school-img"
            :src="background"
            alt="图片加载失败"
          /> -->

          <div class="content">
            <el-image
              v-if="logo"
              :src="logo"
              alt="图片加载失败"
              lazy
              style="max-height: 90%; max-width: 300px"
            ></el-image>

            <div class="msg-box">
              <p class="txt">{{ userInfo.title }}，欢迎您！</p>
              <p style="margin-top: 9px">
                <span>当前班级</span>
                <el-select
                  v-model="major"
                  placeholder="请选择班级"
                  :defaultFirstOption="true"
                  class="uni-select"
                  @change="changeHandler"
                >
                  <el-option
                    v-for="item in userInfo.classList"
                    :key="item.class_id"
                    :value="item.class_id"
                    :label="item.className"
                  ></el-option>
                </el-select>
              </p>
            </div>
          </div>
        </div>

        <div class="weather-box">
          <p class="date">
            {{ date.getFullYear() }}年 {{ date.getMonth() + 1 }}月
            {{ date.getDate() }}日 星期{{ date.getDay() | dayFilter }}
          </p>
          <!-- <div>
            <span class="weathericon"></span>
            <div class="temp">
              <p>{{ weatherData.city }} {{ weatherData.weather }}</p>
              <p>温度 {{ weatherData.temperature }}°</p>
              <p>风向 {{ weatherData.windDirection }}</p>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import { getStore } from "@/utils/localStorage";
import { mapState, mapMutations } from "vuex";
import { selectMajor, getMajor } from "@/api/basic";
import { getPatch } from "@/api/common";
import router from "../../router";
import VueRouter from "vue-router";

export default {
  name: "Header",
  data() {
    return {
      userInfo: JSON.parse(getStore("userInfo")),
      // majorList: [],
      date: new Date(),
      logo: "",
      background: "",
      major: "",
    };
  },
  filters: {
    dayFilter(val) {
      switch (val) {
        case 0:
          return "天";
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        case 4:
          return "四";
        case 5:
          return "五";
        case 6:
          return "六";
        default:
          return null;
      }
    },
  },
  computed: {
     ...mapState("common", [
      'studentMajor'
    ]),
  },
  created() {
    this.getTagPatch("logo").then((res) => {
      this.logo = res.content;
    });
    this.getTagPatch("pc").then((res) => {
      this.background = res.content;
    });

    let majorStore = this.studentMajor;
    this.major = majorStore.class_id;
    this.changeHandler(this.major, 'init');

    // this.getMajorList().then((res) => {
    //   this.majorList = res;
    //   let majorStore = getStore("studentMajor");
    //   this.major = JSON.parse(majorStore).class_id;

    //   if (majorStore) {
    //     // this.major = JSON.parse(majorStore).profession_id;
    //     this.major = JSON.parse(majorStore).class_id;
    //     this.changeHandlerTo(this.major);
    //   } else if (this.majorList && this.majorList.length > 0) {
    //     // this.major = this.majorList[0].profession_id;
    //     this.major = this.majorList[0].class_id;
    //     this.changeHandler(this.major);
    //   }
    // });

  },
  methods: {
    ...mapMutations("common", ["gerStudentMajorMutation"]),
    // logo,background
    async getTagPatch(tag) {
      const params = {
        tag: tag,
      };
      const res = await getPatch(params);
      if (res.code == 200) {
        return res.result;
      }
    },
    // 专业列表
    async getMajorList() {
      const { result } = await getMajor();
      if (result) {
        // console.log(result)
        return result;
      }
    },
    // 专业切换
    async changeHandler(val, type) {
      const obj = this.userInfo.classList.find(item => item.class_id == val);
      const FirstLoginVerify = obj.first_login_verify
      // if(FirstLoginVerify == 0){
      //   this.$router.push({
      //     name: "verify",
      //     query: {
      //       classId: arr[0].class_id,
      //     },
      //   });
      //   return;
      // }
      if (type !== 'init' && this.$route.name !== "home") {
        // this.gerStudentMajorMutation(null);
        await this.$router.replace("/home");
      }

      const res = await selectMajor({
        class_id: val,
      });
      if (res.code == 200) {
        // 判断一下 当前选中的class_id !== 保存的class_id 重新保存
        if(this.studentMajor.class_id !== val){
          let majorStore = this.userInfo.classList.find(item => item.class_id == val);
          this.gerStudentMajorMutation(majorStore);
        }
        // 当为专科时(level == 3) 从写路由 显示专业页面
        if(this.$store.state.permission._ENTRANCETYPE === 'adult'){
          const {level} = res.result;
          if(level == 3){
            this.$store.dispatch('permission/adultTypeActions', 'adultJCE');  //设置成教专科
          }else{
            this.$store.dispatch('permission/adultTypeActions', '');  //设置成教专科
          }
          this.$store.dispatch('permission/setIsGenerateRoutes', true); //设置重置路由状态
          // 路由重写
          this.$store.dispatch('permission/generateRoutes').then((res) => {
            router.matcher = new VueRouter().matcher; // 重置路由
            router.options.routes = res;
            router.addRoutes(res);
          })
        }

        // if (result.profession){
        //   let item = {
        //     class_id: result.class_id,
        //     professionName: result.profession.title,
        //     profession_id: result.profession.id,
        //     content: result.profession.content,
        //     credit: result.profession.credit,
        //   };
        //   this.gerStudentMajorMutation(item);
        // }
      }
    },
    async changeHandlerTo(val) {
      // if (this.$route.name !== "home") {
      //   this.gerStudentMajorMutation(null);
      // }
      const { result } = await selectMajor({
        class_id: val,
      });

      // console.log(result)
      if (result) {
        if ( result.profession){
          let item = {
            class_id: result.class_id,
            professionName: result.profession.title||"",
            profession_id: result.profession.id,
            content: result.profession.content,
            credit: result.profession.credit,
          };
          this.gerStudentMajorMutation(item);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.uni-header {
  .el-input__inner {
    margin-left: 10px;
    background-color: transparent;
    background-image: none;
    border-radius: 0;
    border: 1px solid #fff;
    box-sizing: border-box;
    color: #fff;
    height: 29px;
    line-height: 29px;
    width: auto;
  }

  .el-input__icon {
    line-height: 29px;
    vertical-align: middle;
  }
  .el-select .el-input .el-select__caret {
    color: #fff;
  }

  .el-select .el-input.is-focus .el-input__inner {
    border-color: #fff;
  }
  .el-select .el-input__inner:focus {
    border-color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.uni-header {
  position: relative;
  height: $headH;
  color: $white;
  overflow: hidden;
  @include linearGradient("linear-gradient-start", "linear-gradient-end");

  .container {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
  }

  .shool-box {
    flex: 1;
    margin-left: 200px;
    height: 100%;
  }

  .school-img {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
  }

  .content {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
  }

  .msg-box {
    border-left: 1px solid $white;
    padding: 0 22px;
    margin-left: 22px;

    .txt {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .weather-box {
    width: 400px;
    position: relative;
    .date {
      font-size: 15px;
    }
    .temp {
      font-size: 12px;
    }
  }
}
</style>
